import _Vue from 'vue';
import LoaderComponent from './Loader.vue';
import events from './events';

const LoaderPlugin = {
  install(Vue: typeof _Vue): void {
    Vue.component('loader', LoaderComponent);
    Vue.prototype.$loader = (state: boolean): void => events.$emit('set-state', state);
    Vue.prototype.$loader.show = (): void => events.$emit('show', true);
    Vue.prototype.$loader.hide = (): void => events.$emit('hide', false);
  },
};

export default LoaderPlugin;
